export function isNeedToShowBuildingGroupItemIcons({ isArchived, isHovered }) {
  return isArchived || isHovered
}
